import * as ko from "knockout";
import { ReportViewer } from "../common/reportViewer";
import * as UI from "../common/ui";
import * as Util from "../common/util";
import { IController } from "../interfaces/controller";

interface IViewReportViewModel {
    appointmentID: KnockoutObservable<number>;
}

export class ViewReportController implements IController {
    private container: JQuery;
    private viewModel: IViewReportViewModel;
    private reportViewer: ReportViewer;

    constructor() {
        this.viewModel = {
            appointmentID: ko.observable(),
        };
        this.reportViewer = new ReportViewer();
    }

    public render(container: JQuery): JQueryPromise<any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();
        this.container = container;

        ko.applyBindings(this.viewModel, this.container[0]);

        this.reportViewer.render(this.container.find(".reportContainer"))
            .then(() => {
                deferred.resolve();
            });

        return deferred.promise();
    }

    public load(params: any[]): JQueryPromise<any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        if (params && params.length === 1) {
            this.viewModel.appointmentID(params[0]);

            const reportParameters: any = {};
            for (const p of Util.getURLParameters()) {
                if (p.Key === "appointmentID" || p.Key === "taskID") {
                    // Allow either appointmentID or taskID to work as the param name for single-task reports
                    reportParameters.appointmentID = p.Value;
                    reportParameters.taskID = p.Value;
                } else {
                    reportParameters[p.Key] = p.Value;
                }
            }

            this.reportViewer.loadReport(params[0], reportParameters);

        } else {
            UI.showErrorMessage(["No report specified."]);
        }

        return deferred.promise();
    }

    public appRouterID(params: any): string {

        let taskID = 0;
        if (params && params.length > 0) {
            taskID = params[0];
        }
        let routerID =  `ViewReport${taskID}`;

        for (const p of Util.getURLParameters()) {
            routerID += `${p.Key}${p.Value}`;
        }
        return routerID;
    }

    public title(): string {
        return "View Report";
    }

    public subTitle(): string {
        return "";
    }

    public haveFieldsChanged(): boolean {
        return false;
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/controllers/viewReport.ts